import {
	AgendaBackground,
	AgendaBookingPreviewDisplay,
	AgendaCashDisplay,
	AgendaPaxDisplay,
	AgendaShowTimeslot,
	AgendaThirdRowDisplay,
	AgendaTitleDisplay,
	apiAppSettingsAgendasettingGet,
	type AgendaSetting
} from '#lib/types/generated/index.js';
import { writable } from 'svelte/store';

export const agendaSettingStore = writable<AgendaSetting>({
	showGauge: true,
	titleDisplay: AgendaTitleDisplay.Customer,
	paxDisplay: AgendaPaxDisplay.Remaining,
	showTimeslot: AgendaShowTimeslot.All,
	showCustomerRequest: true,
	showPrivateNote: true,
	showRemainingPayment: true,
	showOrigin: true,
	showOffer: true,
	thirdRowDisplay: AgendaThirdRowDisplay.PrivateNote,
	background: AgendaBackground.Booking,
	cash: AgendaCashDisplay.Remaining,
	displayBookingPreview: AgendaBookingPreviewDisplay.Bottom
});

export async function loadAgendaSettings(): Promise<AgendaSetting> {
	const settings = await apiAppSettingsAgendasettingGet();
	agendaSettingStore.set(settings);
	return settings;
}
